export const DEFAULT_LOCALE = "en";
export const SUPPORTED_LOCALES = ["en", "de", "nl"];
